var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.44 15.1519H0.56C0.25025 15.1519 0 15.4379 0 15.7919V16.5119C0 16.5999 0.063 16.6719 0.14 16.6719H13.86C13.937 16.6719 14 16.5999 14 16.5119V15.7919C14 15.4379 13.7498 15.1519 13.44 15.1519ZM2.54975 13.4719C2.58475 13.4719 2.61975 13.4679 2.65475 13.4619L5.59825 12.8719C5.63325 12.8639 5.6665 12.8459 5.691 12.8159L13.1093 4.33787C13.1255 4.31937 13.1383 4.29739 13.1471 4.2732C13.1559 4.24901 13.1604 4.22307 13.1604 4.19687C13.1604 4.17068 13.1559 4.14474 13.1471 4.12055C13.1383 4.09636 13.1255 4.07438 13.1093 4.05588L10.2008 0.729875C10.1675 0.691875 10.1237 0.671875 10.0765 0.671875C10.0293 0.671875 9.9855 0.691875 9.95225 0.729875L2.534 9.20787C2.50775 9.23787 2.492 9.27387 2.485 9.31387L1.96875 12.6779C1.95173 12.785 1.95781 12.8953 1.98647 12.9991C2.01514 13.103 2.06552 13.1973 2.13325 13.2739C2.24875 13.4019 2.394 13.4719 2.54975 13.4719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/edit-pen-icon.31d5417e5c17808c9e23882dee25f1c7.svg";
export { ForwardRef as ReactComponent };